var Products = /* @__PURE__ */ ((Products2) => {
  Products2["CAR"] = "car";
  Products2["HEALTH_SME"] = "health_sme";
  Products2["MEDICAL_MALPRACTICE"] = "medical_malpractice";
  Products2["HEALTH_INDIVIDUAL"] = "HEALTH_Individual";
  Products2["TRAVEL"] = "travel";
  Products2["PROTECTION_AND_SAVING"] = "protection_and_saving";
  Products2["HOME"] = "home";
  Products2["FLEET_SME"] = "fleet_sme";
  Products2["MARINE"] = "marine";
  Products2["PREMIUM_RESIDENCY"] = "premium_residency";
  return Products2;
})(Products || {});
export {
  Products
};
